'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { EventCalendarProvider as HeadlessEventCalendarProvider } from '@mui/x-scheduler-headless/event-calendar-provider';
import { eventCalendarClasses } from "../../event-calendar/eventCalendarClasses.mjs";
import { EventCalendarStyledContext } from "../../event-calendar/EventCalendarStyledContext.mjs";
import { EventDialogStyledContext } from "./event-dialog/EventDialogStyledContext.mjs";
import { EVENT_CALENDAR_DEFAULT_LOCALE_TEXT } from "../constants/defaultLocaleText.mjs";

/**
 * Root wrapper for standalone views that provides CSS variable tokens.
 * This ensures event colors work correctly outside of EventCalendar.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const StandaloneViewRoot = styled('div', {
  name: 'MuiEventCalendar',
  slot: 'StandaloneViewRoot'
})(({
  theme
}) => ({
  display: 'contents',
  fontFamily: theme.typography.fontFamily,
  boxSizing: 'border-box',
  '*, *::before, *::after': {
    boxSizing: 'inherit'
  }
}));
const calendarStyledValue = {
  classes: eventCalendarClasses,
  localeText: EVENT_CALENDAR_DEFAULT_LOCALE_TEXT
};
const dialogStyledValue = {
  classes: eventCalendarClasses,
  localeText: EVENT_CALENDAR_DEFAULT_LOCALE_TEXT
};
export function EventCalendarProvider(props) {
  const {
      children
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(HeadlessEventCalendarProvider, _extends({}, other, {
    children: /*#__PURE__*/_jsx(EventCalendarStyledContext.Provider, {
      value: calendarStyledValue,
      children: /*#__PURE__*/_jsx(EventDialogStyledContext.Provider, {
        value: dialogStyledValue,
        children: /*#__PURE__*/_jsx(StandaloneViewRoot, {
          children: children
        })
      })
    })
  }));
}